import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import banner9 from "../img/9.avif";
import banner16 from "../img/16.avif";
import banner4 from "../img/4.jpg";
import banner5 from "../img/5.jpg";
import banner6 from "../img/6.jpg";

const slides = [
  {
    id: 1,
    image: banner16,
    label: "Gemstone Shaheen Tower",
    sub: "10 Storied · 36 Units · West Dhanmondi",
  },
  {
    id: 2,
    image: banner9,
    label: "Gemstone Primero",
    sub: "8 Storied · 7 Exclusive Units · Bashundhara",
  },
  {
    id: 3,
    image: banner4,
    label: "Premium Living",
    sub: "Crafted for Exceptional Lifestyles",
  },
  {
    id: 4,
    image: banner5,
    label: "Timeless Architecture",
    sub: "Where Design Meets Comfort",
  },
  {
    id: 5,
    image: banner6,
    label: "Your Dream Home",
    sub: "Developed by Gemstone Real Estate Ltd.",
  },
];

const Banner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Outfit:wght@200;300;400;500&display=swap');

        .banner-root {
          position: relative;
          width: 100%;
          height: 92vh;
          min-height: 580px;
          overflow: hidden;
          background: #0a0a0a;
          font-family: 'Outfit', sans-serif;
        }

        .banner-root .swiper,
        .banner-root .swiper-wrapper,
        .banner-root .swiper-slide { height: 100%; }

        .slide-bg {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          transform: scale(1.08);
          transition: transform 7s ease;
          filter: brightness(0.55) saturate(0.9);
        }
        .swiper-slide-active .slide-bg { transform: scale(1); }

        .overlay-gradient {
          position: absolute;
          inset: 0;
          background:
            linear-gradient(to top, rgba(5,5,10,0.92) 0%, rgba(5,5,10,0.3) 45%, rgba(5,5,10,0.15) 100%),
            linear-gradient(to right, rgba(5,5,10,0.5) 0%, transparent 60%);
          z-index: 1;
        }
        .overlay-noise {
          position: absolute;
          inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.03'/%3E%3C/svg%3E");
          background-size: 180px;
          opacity: 0.4;
          z-index: 2;
          pointer-events: none;
        }

        .gold-bar {
          position: absolute;
          left: 0; top: 0;
          width: 3px; height: 100%;
          background: linear-gradient(to bottom, transparent, #c9a84c, transparent);
          z-index: 10;
        }

        .banner-content {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          z-index: 10;
          padding: 0 6vw 6vh;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          gap: 2rem;
        }

        .banner-text { flex: 1; max-width: 680px; }

        .banner-tag {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          opacity: 0;
          transform: translateY(18px);
          transition: opacity 0.7s 0.2s ease, transform 0.7s 0.2s ease;
        }
        .banner-tag.in { opacity: 1; transform: none; }
        .tag-line { width: 32px; height: 1px; background: #c9a84c; }
        .tag-label {
          font-family: 'Outfit', sans-serif;
          font-size: 11px;
          font-weight: 400;
          letter-spacing: 4px;
          text-transform: uppercase;
          color: #c9a84c;
        }

        .banner-heading {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.6rem, 6vw, 5.2rem);
          font-weight: 300;
          line-height: 1.08;
          color: #f5f0e8;
          margin: 0 0 14px;
          opacity: 0;
          transform: translateY(24px);
          transition: opacity 0.8s 0.35s ease, transform 0.8s 0.35s ease;
          letter-spacing: -0.5px;
        }
        .banner-heading.in { opacity: 1; transform: none; }
        .banner-heading em { font-style: italic; color: #c9a84c; }

        .banner-sub {
          font-size: 13px;
          font-weight: 300;
          color: rgba(245,240,232,0.55);
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 34px;
          opacity: 0;
          transform: translateY(16px);
          transition: opacity 0.7s 0.5s ease, transform 0.7s 0.5s ease;
        }
        .banner-sub.in { opacity: 1; transform: none; }
        .banner-sub::before {
          content: '— ';
          color: #c9a84c;
        }

        .banner-ctas {
          display: flex;
          align-items: center;
          gap: 20px;
          opacity: 0;
          transform: translateY(14px);
          transition: opacity 0.7s 0.65s ease, transform 0.7s 0.65s ease;
        }
        .banner-ctas.in { opacity: 1; transform: none; }

        .btn-primary-gold {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 32px;
          background: #c9a84c;
          color: #0a0a0a;
          font-family: 'Outfit', sans-serif;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: background 0.3s, transform 0.2s;
          clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px));
        }
        .btn-primary-gold:hover { background: #dbbe6a; transform: translateY(-2px); }

        .btn-ghost-white {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 13px 30px;
          background: transparent;
          color: rgba(245,240,232,0.85);
          font-family: 'Outfit', sans-serif;
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 2px;
          text-transform: uppercase;
          text-decoration: none;
          border: 1px solid rgba(245,240,232,0.35);
          cursor: pointer;
          transition: border-color 0.3s, color 0.3s;
        }
        .btn-ghost-white:hover { border-color: #c9a84c; color: #c9a84c; }

        .banner-right {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 28px;
          padding-bottom: 2px;
        }

        .slide-counter {
          font-family: 'Cormorant Garamond', serif;
          font-size: 13px;
          color: rgba(245,240,232,0.5);
          letter-spacing: 2px;
          white-space: nowrap;
          text-align: right;
        }
        .slide-counter strong {
          font-size: 32px;
          font-weight: 300;
          color: #c9a84c;
          line-height: 1;
          display: block;
        }

        .custom-nav { display: flex; gap: 10px; }
        .nav-btn {
          width: 46px; height: 46px;
          border: 1px solid rgba(201,168,76,0.4);
          background: transparent;
          color: rgba(245,240,232,0.8);
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          font-size: 18px;
          transition: background 0.3s, border-color 0.3s;
          clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px));
        }
        .nav-btn:hover { background: rgba(201,168,76,0.2); border-color: #c9a84c; }

        .progress-bar-wrap {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 2px;
          background: rgba(255,255,255,0.1);
          z-index: 20;
        }
        .progress-bar-fill {
          height: 100%;
          background: linear-gradient(to right, #c9a84c, #f0d898);
          transition: width 0.4s ease;
        }

        .scroll-hint {
          position: absolute;
          bottom: 2.5rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 20;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          opacity: 0.4;
          pointer-events: none;
        }
        .scroll-hint span {
          font-size: 9px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #f5f0e8;
          font-family: 'Outfit', sans-serif;
        }
        .scroll-mouse {
          width: 20px; height: 32px;
          border: 1px solid rgba(245,240,232,0.5);
          border-radius: 10px;
          display: flex;
          justify-content: center;
          padding-top: 5px;
        }
        .scroll-dot {
          width: 3px; height: 6px;
          background: #c9a84c;
          border-radius: 2px;
          animation: scrollDot 2s infinite ease-in-out;
        }
        @keyframes scrollDot {
          0%,100% { transform: translateY(0); opacity: 1; }
          60% { transform: translateY(10px); opacity: 0; }
        }

        .banner-root .swiper-pagination { display: none; }
        .banner-root .swiper-button-next,
        .banner-root .swiper-button-prev { display: none; }

        @media (max-width: 768px) {
          .banner-right { display: none; }
          .banner-content { padding: 0 5vw 5vh; }
          .banner-heading { font-size: clamp(2rem, 9vw, 3.2rem); }
          .btn-ghost-white { display: none; }
          .scroll-hint { display: none; }
        }
      `}</style>

      <div className="banner-root">
        <div className="gold-bar" />

        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          slidesPerView={1}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          speed={1200}
          loop
          autoplay={{ delay: 5500, disableOnInteraction: false }}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.realIndex);
            setIsVisible(false);
            setTimeout(() => setIsVisible(true), 80);
          }}
          onSwiper={(s) => {
            swiperRef.current = s;
          }}
          className="h-full"
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div
                className="slide-bg"
                style={{ backgroundImage: `url(${slide.image})` }}
              />
              <div className="overlay-gradient" />
              <div className="overlay-noise" />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Content */}
        <div className="banner-content">
          <div className="banner-text">
            <div className={`banner-tag ${isVisible ? "in" : ""}`}>
              <div className="tag-line" />
              <span className="tag-label">Gemstone Real Estate Ltd.</span>
            </div>

            <h1 className={`banner-heading ${isVisible ? "in" : ""}`}>
              {slides[activeIndex].label.split(" ").length > 1 ? (
                <>
                  {slides[activeIndex].label.split(" ").slice(0, -1).join(" ")}{" "}
                  <em>{slides[activeIndex].label.split(" ").slice(-1)}</em>
                </>
              ) : (
                <em>{slides[activeIndex].label}</em>
              )}
            </h1>

            <p className={`banner-sub ${isVisible ? "in" : ""}`}>
              {slides[activeIndex].sub}
            </p>

            <div className={`banner-ctas ${isVisible ? "in" : ""}`}>
              <a href="#projects" className="btn-primary-gold">
                Explore Projects
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </a>
              <a href="/contact" className="btn-ghost-white">
                Contact Us
              </a>
            </div>
          </div>

          <div className="banner-right">
            <div className="slide-counter">
              <strong>0{activeIndex + 1}</strong>/ 0{slides.length}
            </div>
            <div className="custom-nav">
              <button
                className="nav-btn"
                onClick={() => swiperRef.current?.slidePrev()}
                aria-label="Previous"
              >
                ←
              </button>
              <button
                className="nav-btn"
                onClick={() => swiperRef.current?.slideNext()}
                aria-label="Next"
              >
                →
              </button>
            </div>
          </div>
        </div>

        <div className="progress-bar-wrap">
          <div
            className="progress-bar-fill"
            style={{ width: `${((activeIndex + 1) / slides.length) * 100}%` }}
          />
        </div>

        <div className="scroll-hint">
          <div className="scroll-mouse">
            <div className="scroll-dot" />
          </div>
          <span>Scroll</span>
        </div>
      </div>
    </>
  );
};

export default Banner;
